var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1.41211","width":"32","height":"1","transform":"rotate(45 1.41211 0)","fill":"white","key":0}),React.createElement("rect",{"x":"23.334","y":"0.707031","width":"32","height":"1","transform":"rotate(135 23.334 0.707031)","fill":"white","key":1})]);
}

Cross.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = Cross;

Cross.default = Cross;
